import {
    LoadScript
} from "@react-google-maps/api";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import MapComponent from "../../helper/MapComponent";
import DashboardKycSideBar from "../dashboard/dashboardSidebar";
import Biometrics from "../kyc/Biometrics";
import { getBlob } from "../kyc/CaptureImage";
import CustomImage from "../other/Image";
import VideoApiService from "../service/VideoApiService";
import apiService from "../service/apiService";
import fileUploadService from "../service/fileUploadService";
import postApiService from "../service/postApiService";
import { useToast } from "./Toast";
import ApiBaseURLProps from "./apiBaseURL";

let send = null;
let sendMessage = null;
const VideoChat = () => {

    const toast = useToast();
    const searchParams = new URLSearchParams(useLocation().search);
    const mobileView = searchParams.get('mobileView');

    const [viewBiometrics, setViewBiometrics] = useState();
    const history = useHistory();
    const [data, setData] = useState();
    const { t, i18n } = useTranslation();
    const { tempKycId, permKycId, status, customerId, formType } =
        useSelector((state) => state.routerData) || {};

    const [online, setOnline] = useState();
    const [checkOnline, setCheckOnline] = useState(0);
    const [lstream, setLstream] = useState();
    const [imgSrc, setImgSrc] = useState();
    const [imgSrcData, setImgSrcData] = useState();
    const lstreamRef = useRef();
    const rstreamRef = useRef();
    const cavRef = useRef();
    const [showKycDialog, setShowKycDialog] = useState(false);
    const [duplicateDialog, setDuplicateDialog] = useState(false);
    const [duplicateList, setDuplicateList] = useState({});
    const [errorCode, setErrorCode] = useState();
    const [checkData, setCheckData] = useState({ status: 'L' });
    let { id } = useParams();
    const [error, setError] = useState(false);

    const dispatch = useDispatch();
    const [LatLng, setLatLngState] = useState({
        "mapPosition": {
            "lat": null,
            "lng": null
        },
        "markerPosition": {
            "lat": null,
            "lng": null
        }
    });


    const fetchData = () => VideoApiService.get(customerId).then(r => {
        setCheckData({
            ...r.data,
            status: (!r.data.status || r.data.status === 'I' ? 'P' : r.data.status),
            documentPhotoVerfData: r.data.documentPhotoVerf && JSON.parse(r.data.documentPhotoVerf),
            userPhotoVerf: r.data.userPhotoVerf && JSON.parse(r.data.userPhotoVerf),
            documentVerf: r.data.documentVerf && JSON.parse(r.data.documentVerf),
        });
    })
    useEffect(() => {
        if (customerId)
            fetchData();
    }, [customerId
    ]);


    useEffect(() => {
        if (!customerId || checkData.status === 'L' || (checkData.status && checkData.status !== 'P')) return;
        //saman dai function:
        function handleCaptureImage() {
            let ctx = cavRef.current.getContext('2d');
            ctx.drawImage(lstreamRef.current, 0, 0, cavRef.current.width, cavRef.current.height);

            console.log('image:: ', cavRef.current.toDataURL('image/jpeg'));
            setImgSrc(cavRef.current.toDataURL('image/jpeg'));

            getBlob(cavRef.current).then(img => {
                fileUploadService.uploadFile(img, "capture.jpg")
                    .then(r => {
                        send({
                            event: "captureImageUrl",
                            data: r.data
                        });
                    });
            });
        }
        postApiService
            .getCustomerUser().then((response) => {
                console.log(response.data);
                setData(response.data);
            }).catch(() => {
                setError(true);
            });

        // const configuration = {
        //     iceServers: [
        //         {
        //             urls: "turn:" + ApiBaseURLProps.videoUrl + ":8045?transport=tcp",
        //             credential: "password",
        //             username: "guest"
        //         }
        //     ]
        // };

        const configuration = {
            iceServers: [
                // { urls: "stun:ckyc.cdsc.com.np" }, // STUN server example
                {
                    urls: "turn:" + ApiBaseURLProps.videoUrl + ":3478?transport=udp", username: "guest", credential: "password",
                    //  credentialType: "password", realm: "ckyc.cdsc.com.np" 
                }, // TURN server example
                // { urls: "turn:ckyc.cdsc.com.np:5349?transport=tcp", username: "guest", credential: "password",
                // //  credentialType: "password", realm: "ckyc.cdsc.com.np" 
                // } // TURN server example with TCP
                {
                    urls: "stun:stun.l.google.com:19302",
                },
                {
                    urls: "stun:stun1.l.google.com:19302",
                },
                {
                    urls: "stun:stun2.l.google.com:19302",
                },
                {
                    urls: "stun:stun3.l.google.com:19302",
                },
                {
                    urls: "stun:stun4.l.google.com:19302",
                },
                {
                    urls: "stun:global.stun.twilio.com:3478",
                },
                {
                    urls: "stun:stun.relay.metered.ca:80",
                },
                {
                    urls: "turn:standard.relay.metered.ca:80",
                    username: "0f9dac70155e5fd3b05e3701",
                    credential: "8Uvp/u8Dghvq9w5E",
                },
                {
                    urls: "turn:standard.relay.metered.ca:80?transport=tcp",
                    username: "0f9dac70155e5fd3b05e3701",
                    credential: "8Uvp/u8Dghvq9w5E",
                },
                {
                    urls: "turn:standard.relay.metered.ca:443",
                    username: "0f9dac70155e5fd3b05e3701",
                    credential: "8Uvp/u8Dghvq9w5E",
                },
                {
                    urls: "turns:standard.relay.metered.ca:443?transport=tcp",
                    username: "0f9dac70155e5fd3b05e3701",
                    credential: "8Uvp/u8Dghvq9w5E",
                },
            ]
        };

        const log = message => {
            console.log(`[${new Date().toLocaleTimeString()}] ${message}`);
        };

        log('Initializing...');

        let pc = new RTCPeerConnection(configuration);

        // Logging ICE connection state changes
        pc.oniceconnectionstatechange = event => {
            log(`ICE connection state changed: ${pc.iceConnectionState}`);
        };

        // Logging ICE candidate generation
        pc.onicecandidate = event => {
            if (event.candidate) {
                console.log('ICE candidate:', event.candidate);
                // Send the ICE candidate to the remote peer
                if (typeof sendMessage === 'function')
                    sendMessage({ type: 'candidate', candidate: event.candidate });
            } else {
                console.log('ICE gathering complete');
                const connectionState = pc.iceConnectionState;
                if (connectionState === 'connected' || connectionState === 'completed') {
                    //   console.log('TURN server test successful!');
                    toast.success("Successful", "Video Server connection successful!");
                }
                else if (connectionState === 'checking') {
                    setTimeout(() => {
                        const updatedConnectionState = pc.iceConnectionState;
                        if (updatedConnectionState === 'connected' || updatedConnectionState === 'completed') {
                            console.log('Video Server connection successful!');
                            toast.success("Successful", "Video Server connection successful!");
                        } else {
                            console.log('Still checking...');
                        }
                    }, 5000);
                    console.log('Checking turn server');
                }
                else {
                    //   console.error('TURN server test failed.');
                    toast.error("Unsuccessful", "Video Server connection unsucessful!");
                }
            }
        };

        // Logging received remote tracks
        pc.ontrack = event => {
            log('Received remote track:', event.track);
            // document.getElementById('remoteVideo').srcObject = event.streams[0];

            rstreamRef.current.srcObject = event.streams[0];
            rstreamRef.current.muted = false;
            rstreamRef.current.play();
            log('Remote stream added to the video element:', event.streams[0]);
        };

        function ping() {
            if (checkOnline > 2) {
                setOnline(false);
            }

            setCheckOnline(checkOnline + 1);

            if (typeof sendMessage === 'function')
                sendMessage({
                    event: "ping",
                    data: null
                });
        }
        // Establish WebSocket connection
        const ws = new WebSocket('wss://' + ApiBaseURLProps.videoUrl + '/api/video-kyc/socket?id=' + customerId);


        sendMessage = message => {
            // sendMessage = (message) => {

            ws.send(JSON.stringify(message));
        };
        ws.onopen = function () {
            console.log("Connected to the signaling server");
            ping();
            setInterval(ping, 5000);
        };

        // Handle WebSocket messages
        ws.onerror = function (event) {
            toast.error("Unsuccessful", "Websocket server not reachable.");
        };
        ws.onclose = function (event) {
            console.log('WebSocket connection closed');
        };
        // Handle WebSocket messages
        ws.onmessage = event => {
            const message = JSON.parse(event.data);
            if (message.type === 'offer') handleOffer(message.offer);
            else if (message.type === 'answer') handleAnswer(message.answer);
            else if (message.type === 'candidate') handleCandidate(message.candidate);
            else if (message.event === 'finish') window.location.href = '/kyc/dashboard';
            else if (message.event === 'updateData') setCheckData(message.data);
            else if (message.event === 'ping') {
                setCheckOnline(0);
                setOnline(true);
            }
            else if (message.event === 'captureImage') handleCaptureImage(message.data);
            else if (message.event === 'image_documentPhotoId') setCheckData({ ...checkData, documentPhotoId: message.data });
            else if (message.event === 'image_userPhotoId') setCheckData({ ...checkData, userPhotoId: message.data });
        };

        // Send WebSocket message


        // Function to handle received offer
        const handleOffer = async offer => {
            // Set remote description
            await pc.setRemoteDescription(offer);
            // Create answer
            const answer = await pc.createAnswer();
            await pc.setLocalDescription(answer);
            // Send answer back to caller
            if (typeof sendMessage === 'function')
                sendMessage({ type: 'answer', answer: answer });
        };

        // Function to handle received answer
        const handleAnswer = async answer => {
            await pc.setRemoteDescription(answer);
        };

        // Function to handle received ICE candidate
        const handleCandidate = candidate => {
            pc.addIceCandidate(new RTCIceCandidate(candidate));
        };

        log('Waiting for offer from caller...');

        // Get user media and start call
        navigator.mediaDevices.getUserMedia({ video: true, audio: true })
            .then(stream => {
                console.log('getUserMedia() succeeded:', stream);
                // Display local video (optional)
                // document.getElementById('localVideo').srcObject = stream;

                lstreamRef.current.srcObject = stream;
                lstreamRef.current.play();
                stream.getTracks().forEach(track => pc.addTrack(track, stream));

                // If you want to initiate the call from the receiver side,
                // you can create an offer here and send it to the caller
                // return pc.createOffer();
            })
            .then(offer => {
                // console.log('createOffer() succeeded:', offer);
                // return pc.setLocalDescription(offer);
            })
            .then(() => {
                // console.log('setLocalDescription() succeeded');
                // Send the local description to the remote peer (caller)
                // sendMessage({ type: 'offer', offer: pc.localDescription });
            })
            .catch(error => {
                toast.error("Unsuccessful", "Unable to access camera or microphone.");
                console.error('getUserMedia() failed:', error);
            });
    }, [customerId, checkData.status]);

    const setCheckValue = (field, value) => {
        if (value) {

            // sendMessage({
            //     event: "updateData",
            //     data: { [field]: "asdf" }
            // });
            if (typeof sendMessage === 'function')
                sendMessage({
                    event: "updateData",
                    data: { ...checkData, [field]: value }
                });
            return checkData;
            // setCheckData(ps => {
            //     console.log('field-check: ', field);
            //     return {[field]: "asdf" };
            // });
        }
        else {
            return (e) => {
                setCheckData(ps => {
                    if (typeof sendMessage === 'function')
                        sendMessage({
                            event: "updateData",
                            data: { ...ps, ["abc"]: !ps[field] }
                        });
                    console.log('field-check: ', field);
                    return { ...ps, [field]: !ps[field] };
                });
            }
        }
    };

    const body = <div className="p-grid" style={{ marginBottom: '5%' }}>

        {!checkData.status && <div>Starting...</div>}
        {checkData.status === 'S' && <div>Already Successfully completed</div>}
        {checkData.status === 'D' && <div>Already Dissmissed</div>}
        {(checkData.status === 'P') &&

            <div className="p-col-12 p-md-9 compact-layout" >
                <div style={{ backgroundColor: 'black', height: 405, borderRadius: 10 }}>
                    <video ref={rstreamRef} style={{ width: '-webkit-fill-available', borderRadius: 10 }} autoplay muted>

                    </video>
                    <div style={{ position: 'relative' }}>
                        <video ref={lstreamRef} style={{ width: '174px', height: '130px', position: 'absolute', bottom: '6px', right: 0, backgroundColor: 'green', borderRadius: 10 }} autoplay  ></video>
                    </div>
                </div>
            </div>
        }

        <div className="p-col-12 p-md-3 compact-layout" >

            {data && <Objective readOnly={true} data={data} checkData={checkData} />}

            {<ObjectiveFinal readOnly={true} checkData={checkData} setCheckValue={setCheckValue} />}

            <Button
                style={{
                    borderRadius: "19px",
                    minWidth: "122px",
                    margin: 5,
                }}
                onClick={(e) => {
                    setViewBiometrics(true);
                }}
            >
                <span>
                    <i className="pi pi-id-card" />
                    {' '}Biometrics
                </span>
            </Button>

            <Biometrics viewBiometrics={viewBiometrics} setViewBiometrics={setViewBiometrics} />

            <div className="p-col-12 p-md-3 compact-layout" >
                <h4 className="section-title">GeoLocation</h4>
                <div style={{ width: 750, margin: "0px auto" }}>
                    <MapComponent
                        onChange={(data) => {
                            if (data.markerPosition && data.markerPosition.lat) {
                                setCheckValue("Location", data);
                            }
                            // setEditFullName(e.target.value);
                        }}
                        LatLng={LatLng}
                    />
                </div>
            </div>
        </div>

    </div>
    if (mobileView === "true")
        return <div
            style={{ overflowX: 'hidden' }} className='main-card'>
            {body}

        </div>;
    else
        return <div className="p-grid">

            {checkData && <div id="kycForm"
                className={"p-col-12 p-md-9 compact-layout"}
            >
                <div
                    style={{ padding: 25 }}
                    className="p-col-12 p-md-12"
                >
                    <Card
                        style={{ overflowX: 'hidden' }}
                        className='main-card'
                        header={
                            <>
                                {!(mobileView === "true") && <div style={{ display: 'flex' }}>
                                    <h3 className='p-col-12 p-md-10 text-center'>
                                        <i className='pi pi-user' /> {t('Video KYC')}
                                    </h3>{' '}
                                    <div style={{ bottom: '6px' }}>
                                        <Button
                                            className='p-col-12 p-md-2 add-button'
                                            label={'Back'}
                                            type='submit'
                                            style={{ width: 100 }}
                                            onClick={() => history.push('/kyc/dashboard')}
                                        />
                                    </div>
                                </div>
                                }</>
                        }
                    >

                        {body}
                    </Card>
                </div>
            </div >
            }
            <DashboardKycSideBar />
        </div >

}


export const familyName = (row) => {
    if (!row || !row.personDetail) return '';
    const mname = row.personDetail.mname ? row.personDetail.mname + " " : "";
    return row.personDetail.fname + "  " + mname + row.personDetail.lname;
};

export const familyNameNep = (row) => {
    if (!row || !row.personDetail) return '';
    const mname = row.personDetail.mnameNep ? row.personDetail.mnameNep + " " : "";
    return ((row.personDetail.fnameNep || '') + "  " + mname + (row.personDetail.lnameNep || '')).trim();
};


const Objective = (props) => {
    const [districtList, setDistrictList] = useState();
    useEffect(() => {
        apiService.getDistrictList().then((response) => {
            console.log(response);
            setDistrictList(response.data.data);
        });
    }, [])
    const {
        id,
        personDetail,
        companyDetail,
        bankAccountDetailList,
        boIdList,
        dynamicDataList,
        permKycId,
        tempKycId,
        hideHeader,
    } = props.data;

    const checkData = props.checkData;
    const setCheckValue = props.setCheckValue || (() => console.log("df"));

    const {
        addressDetailList,
        occupationDetailList,
        familyDetailList,
        guardianDetail,
        directorDetailList,
    } = personDetail || companyDetail || {};
    const personDocumentDetailList = personDetail
        ? personDetail.personDocumentDetailList
        : companyDetail.documentDetailList;

    const name = familyName({ personDetail }) || companyDetail.name;
    const nameNep = familyNameNep({ personDetail });
    const address = addressDetailList && addressDetailList.filter(a => a.addressTypeId = 2)
        .map(a => {
            return (a.countryDesc || '') + ', ' +
                (a.stateDesc || '') + ', ' +
                (a.districtDesc || '') + ', ' +
                (a.municipalityDesc || '') + '-' +
                (a.ward || '') + ', ' +
                (a.tole || '');
        }).find(a => a);

    const document =
        personDetail &&
        (personDocumentDetailList.find((d) => d.documentTypeId === "CZ") ||
            personDocumentDetailList.find((d) => d.documentTypeId === "PP") ||
            personDocumentDetailList.find((d) => d.documentTypeId === "PP"));

    const dob = personDetail && personDetail.dob;
    const dobBs = personDetail && personDetail.dobBs;
    const grandFatherObj = familyDetailList && familyDetailList.find((p) => p.relationTypeId == "GF");
    const fatherObj = familyDetailList && familyDetailList.find((p) => p.relationTypeId == "F");
    const spouseObj = familyDetailList && familyDetailList.find((p) => p.relationTypeId == "SP");

    const gFatherName = familyName(grandFatherObj);
    const fatherName = familyName(fatherObj);
    const spouseName = familyName(spouseObj);


    const getDescription = (pList, param) => {
        return param && ((pList && pList.find((p) => p.code === param)) || {}).descEng;
    };

    console.log('checkData:', checkData);
    const readOnly = props.readOnly;

    return (<table className="video-kyc-table" style={{ fontSize: 15 }}>
        <tr><td colSpan={3}>
            <h4 style={{ borderBottom: '1px solid #efefef' }}>User Details {!readOnly && (props.online ? <> <span style={{ color: 'green', fontSize: '5em' }}>.</span> Online </> : <> <span style={{ color: '#efefef', fontSize: '5em' }}>.</span> Offline </>)}</h4>
        </td></tr>
        <tr><td><CheckInput disabled={readOnly} value="isNameValid" checked={checkData.isNameValid} onChange={setCheckValue('isNameValid')} className="video-kyc-check" /></td><td> Name : </td><td>{name} {!!nameNep && `(${nameNep})`}</td></tr>
        {dob && <tr><td><CheckInput disabled={readOnly} value="isDobValid" checked={checkData.isDobValid} onChange={setCheckValue('isDobValid')} className="video-kyc-check" /></td><td> DOB : </td><td>{dob} A.D {!!dobBs && `(${dobBs} B.S)`} </td></tr>}
        <tr><td><CheckInput disabled={readOnly} value="isAddressValid" checked={checkData.isAddressValid} onChange={setCheckValue('isAddressValid')} className="video-kyc-check" /></td><td> Address : </td><td>{address}</td></tr>
        {gFatherName && <tr><td><CheckInput disabled={readOnly} value="isGfnValid" checked={checkData.isGfnValid} onChange={setCheckValue('isGfnValid')} className="video-kyc-check" /></td><td> Grand Father : </td><td>{gFatherName}</td></tr>}
        {fatherName && <tr><td><CheckInput disabled={readOnly} value="isFnValid" checked={checkData.isFnValid} onChange={setCheckValue('isFnValid')} className="video-kyc-check" /></td><td> Father : </td><td>{fatherName}</td></tr>}
        {spouseName && <tr><td><CheckInput disabled={readOnly} value="isSpValid" checked={checkData.isSpValid} onChange={setCheckValue('isSpValid')} className="video-kyc-check" /></td><td> Spouse : </td><td>{spouseName}</td></tr>}
        {document && document.docId && <tr><td><CheckInput disabled={readOnly} value="isDocumentIdValid" checked={checkData.isDocumentIdValid} onChange={setCheckValue('isDocumentIdValid')} className="video-kyc-check" /></td><td> Document ({document.documentTypeDesc || 'Identity'}) : </td><td>{getDescription(districtList, document.issuedFrom)}, {document.docId}, {document.issuedDate && document.issuedDate.split('-')[0]}</td></tr>}
        {props.setShowKycDialog && <tr><td colSpan={3}>
            <Button label="View KYC Detail" icon="pi pi-window-maximize" onClick={() => {
                props.setShowKycDialog(true);
            }} />
        </td></tr>}
    </table>)
}

const ObjectiveFinal = (props) => {
    const toast = useToast();
    const [loading, setLoading] = useState(false);

    const checkData = props.checkData;
    const setCheckValue = props.setCheckValue || (() => console.log("df"));
    const setCheckData = props.setCheckData || (() => console.log("df"));
    const readOnly = props.readOnly;

    return (<table className="video-kyc-table" style={{ fontSize: 15, width: '100%' }}>
        <tr><td>
        </td></tr><tr><td>
            <h4 style={{ borderBottom: '1px solid #efefef' }}>User Photo</h4>
        </td></tr><tr><td>
            <CheckInput disabled={readOnly} value="isKycPhotoValid" checked={checkData.isKycPhotoValid} onChange={setCheckValue('isKycPhotoValid')} className="video-kyc-check" /> Is KYC Photo valid
        </td></tr><tr><td>
            {checkData.userPhotoId && <CustomImage src={ApiBaseURLProps.apiBaseURL + "/file/" + checkData.userPhotoId} width="144" height="108" style={{ width: 144, height: 108 }} preview />}
        </td></tr><tr><td>
            {checkData.userPhotoId && checkData.documentPhotoVerf && (checkData.documentPhotoVerf.matchPhotoFile ? <span><i className="pi pi-check-circle" style={{ color: 'green' }} /> Matches with KYC photo</span> : <span><i className="pi pi-times-circle" style={{ color: 'red' }} /> Does not matches with KYC photo</span>)}
        </td></tr><tr><td>
            {!readOnly && <Button id="capture" icon="pi pi-camera" onClick={props.onClickPhoto} label="Capture User Photo"></Button>}
        </td></tr><tr><td>
        </td></tr><tr><td>
            <h4 style={{ borderBottom: '1px solid #efefef' }} >User Document Photo</h4>
        </td></tr><tr><td>
            <CheckInput disabled={readOnly} value="isDocumentValid" checked={checkData.isDocumentValid} onChange={setCheckValue('isDocumentValid')} className="video-kyc-check" /> Is User Document valid
        </td></tr><tr><td>
            {checkData.documentPhotoId && <CustomImage src={ApiBaseURLProps.apiBaseURL + "/file/" + checkData.documentPhotoId} width="144" height="108" style={{ width: 144, height: 108 }} preview />}
        </td></tr><tr><td>
            {checkData.documentPhotoId && checkData.documentPhotoVerf && (checkData.documentPhotoVerf.matchVdocumentFile ? <span><i className="pi pi-check-circle" style={{ color: 'green' }} /> Contains captured user photo</span> : <span><i className="pi pi-times-circle" style={{ color: 'red' }} /> Does not contains captured user photo</span>)}
        </td></tr><tr><td>
            {!readOnly && <Button id="capture2" icon="pi pi-camera" onClick={props.onClickDocument} label="Capture Document Photo"></Button>}
        </td></tr><tr><td>
        </td></tr><tr><td>
            <h4 style={{ borderBottom: '1px solid #efefef' }} >User Signature Photo</h4>
        </td></tr><tr><td>
            <CheckInput disabled={readOnly} value="isSignatureValid" checked={checkData.isSignatureValid} onChange={setCheckValue('isSignatureValid')} className="video-kyc-check" /> Is User Signature valid
        </td></tr><tr><td>
            {checkData.signaturePhotoId && <CustomImage src={ApiBaseURLProps.apiBaseURL + "/file/" + checkData.signaturePhotoId} width="144" height="108" style={{ width: 144, height: 108 }} preview />}
        </td></tr>{checkData.signaturePhotoId && <tr><td>
            <CheckInput disabled={readOnly} value="useSignature" checked={checkData.useSignature} onChange={setCheckValue('useSignature')} className="video-kyc-check" /> Use captured Signature in KYC
        </td></tr>}<tr><td>
            {!readOnly && <Button id="capture2" icon="pi pi-camera" onClick={props.onClickSignature} label="Capture Signature Photo"></Button>}
        </td></tr><tr><td>
            {!readOnly && <Button loading={loading} onClick={() => {
                setLoading(true);
                VideoApiService.analyze(checkData.id).then(r => {
                    setCheckData({ ...checkData, documentPhotoVerf: r.data });
                    toast.success("Successful", "Analysis successfully");
                }).catch(r => {
                    console.log(r.data);
                    toast.error("Unsuccessful", "Analysis unsuccessfully");
                }).finally(() => {
                    setLoading(false);
                })
            }} label="Analyze image"></Button>}
        </td></tr>
    </table>)
}

const CheckInput = (props) => {
    return !props.disabled ? <Checkbox {...props} /> : (props.checked ? <i className="pi pi-check-circle" style={{ color: 'green' }} /> : props.checked == null ? <i className="pi pi-exclamation-triangle" style={{ color: 'yellow' }} /> : <i className="pi pi-times-circle" style={{ color: 'red' }} />)
}

export default VideoChat;